import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GECKO_CONSTS, GeckoField } from 'ui';
import AsyncSelect from 'components/AsyncSelect';

class BotSelect extends Component {
  static propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
    multi: PropTypes.bool,
    placeholder: PropTypes.string,
  };

  handleChange(_key, value) {
    this.props.onChange(value);
  }

  render() {
    const field = {
      key: 'value',
      type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
      component: (
        <AsyncSelect
          multi={this.props.multi}
          getUrl="/bots"
          selectUrl="/bots"
          optionTransform={(bot) => ({ label: bot.name, value: bot.id })}
          field={{
            config: { placeholder: this.props.placeholder },
          }}
        />
      ),
    };
    return (
      <div className="BotSelect">
        <GeckoField
          field={field}
          values={{ value: this.props.value }}
          handler={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

export default BotSelect;
